import React from 'react';


export default function Header() {
  return (
    <div className="header">
      <h1>
        <span className="title-caps">G</span>et&nbsp;
        <span className="title-caps">C</span>at&nbsp;
        <span className="title-caps">S</span>tuff
      </h1>
      <h4>Guess the helper bot's decision and you get... cat stuff >:3</h4>
      <h6><em>Disclaimer: Quality and accuracy of cat fact may vary.</em></h6>
    </div>
  )
}
